module.exports = __webpack_public_path__ + "static/media/interrogacao.0d3bf237.svg";